import type { DicMajorListParams } from "../types";

export const dicMajorPageSizeOptions = [20, 50, 100] as const;

export const dicMajorDefaultListParams: DicMajorListParams = {
  page: 1,
  pageSize: 20,
  sortField: "sort_no",
  sortDirection: "asc",
};

export const dicMajorStatusOptions = [
  { label: "全部状态", value: "" },
  { label: "启用", value: "false" },
  { label: "停用", value: "true" },
] as const;

